require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/symbol/iterator.js
// module id = 415
// module chunks = 2 92